import { render, staticRenderFns } from "./EarlyAccess.vue?vue&type=template&id=18851354&scoped=true&"
import script from "./EarlyAccess.vue?vue&type=script&lang=js&"
export * from "./EarlyAccess.vue?vue&type=script&lang=js&"
import style0 from "./EarlyAccess.vue?vue&type=style&index=0&id=18851354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18851354",
  null
  
)

export default component.exports